const hasValue = value => value !== undefined && value !== null && String(value).trim() !== ''

export const materialImagePath = value => {
  const path = typeof value === 'string' ? value.trim() : ''
  return path && (!/^[a-z][a-z0-9+.-]*:/i.test(path) || /^https?:\/\//i.test(path)) ? path : ''
}

// 由调用页提供查询方法，保留各页面现有的权限检查和接口错误处理。
export async function getMaterialImageUrls(row, corpid, queryRows) {
  let materialId = row.MATIDSEQ || row.MAT_IDSEQ
  if (!hasValue(materialId)) {
    if (!hasValue(row.MATNO)) throw new Error('缺少物料编码，无法读取图片')
    const records = await queryRows({
      p_table: 'V_BS_mat', p_key: 'corpid', p_value: corpid,
      p_key2: 'idno', p_value2: row.MATNO
    })
    const matches = records.filter(item => String(item.CORPID) === String(corpid) && String(item.IDNO) === String(row.MATNO) && hasValue(item.IDSEQ))
    const ids = Array.from(new Set(matches.map(item => String(item.IDSEQ))))
    if (ids.length !== 1) throw new Error('未找到唯一的物料主档：' + row.MATNO)
    materialId = ids[0]
  }
  const records = await queryRows({
    p_key: 'idseq', p_value: String(materialId), p_key2: '', p_value2: '', p_table: 'V_mat_img'
  }, 'xuper_auth/getTableRecMany')
  return Array.from(new Set(records.filter(item => item.FILETY === 'IMG' && String(item.IDSEQ) === String(materialId))
    .map(item => materialImagePath(item.FILEPATH)).filter(Boolean)))
}
